import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgSecurityDeposit(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="12 10 36 40"
      fill="none"
      {...props}
    >
      <path
        stroke={props.primaryColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20.44 26.6c0-8.16 0-13.6 9.52-13.6s9.52 5.44 9.52 13.6M15 26.6V47h29.92V26.6z"
      />
      <path
        stroke={props.secondaryColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.72}
        d="M29.927 34.561v4.08M31.585 38.707a1.659 1.659 0 0 1-3.317 0"
      />
    </svg>
  );
}
export default SvgSecurityDeposit;
